module.exports = __webpack_public_path__ + "static/img/summitmapLogo.11c63c50.png";